import { FTunnelPageBookingTypeEnum, FTunnelPageStepEnum } from '@/types/tunnel';
export const INITIAL_PAGE_CONTEXT = {
    formErrors: null,
    pageName: null,
    tunnelStep: FTunnelPageStepEnum.booking,
    bookingType: FTunnelPageBookingTypeEnum.standard,
    experienceId: null
};
